import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import ProductCarousel from '../../tissues/product-carousel';
import MobilePDPImageCarousel from '../../tissues/pdp-mobile-image-carousel';
import MobilePaidProductInformation from '../../organisms/pdp-paid-mobile-information';
import PDPCarousels from '../pdp-carousels';
import BazaarVoiceRatings from '../../atoms/bazaar-voice/ratings';
import { EGROWTHBOOK_FEATURES_FLAGS } from '../../utils/growthbook-constants';


const MobileProductWrapper = styled.div``;

const MobilePaidProduct = styled.div`
  display: grid;
  grid-gap: 3rem;
  grid-template-areas: 'product-carousel' 'product-information' 'bazaarvoice' 'overview-image';
  grid-template-columns: minmax(0, 1fr);
  margin-bottom: 3rem;
`;

const MaisonetteOverviewImage = styled.img`
  grid-area: overview-image;
  // there is a default Content padding of 3rem on each side
  // add 6 rems to image and use neg margin to stretch image
  // across entire screen
  width: calc(100% + 6rem);
  height: auto;
  margin: 0 -${({ theme }) => theme.modularScale.thirty};
`;

const MobilePaidProductDetails = ({
  product, hasImages, productType, hasRecommendations, recentlyViewed, meta, growthbookFeatureFlagValues
}) => {
  const { [EGROWTHBOOK_FEATURES_FLAGS.BAZAARVOICE_ENABLED]: bazaarvoiceEnabled } =
    growthbookFeatureFlagValues || {};
  
  // Default to true if flag is undefined (fallback to default behavior)
  const isBazaarvoiceEnabled = bazaarvoiceEnabled !== undefined ? bazaarvoiceEnabled : true;

  return (
    <MobileProductWrapper data-vwo-id="MobilePaidProductWrapper">
      <MobilePaidProduct>
        {
          hasImages && (
            <>
              <ProductCarousel
                data-vwo-id="MobilePaidProductCarousel"
                product={product}
                images={product?.master?.images}
                name={product?.master?.name}
                productType={productType}
                />
              <MobilePDPImageCarousel 
              product={product}
              images={product?.master?.images}
              name={product?.master?.name}
              productType={productType}
              />
            </>
          )
        }

        <MobilePaidProductInformation
          product={product}
          data-vwo-id="MobilePaidProductInformation"
          meta={meta}
          growthbookFeatureFlagValues={growthbookFeatureFlagValues}
        />
        {/* TODO: TEC-8758 - For BV we're currently using the slug instead of product
                  id because of a backend data issue with the product feed. If the BE
                  fix the data issue, we will need to update data-bv-product-id to 
                  the correct value. */}
        {isBazaarvoiceEnabled && (
          <BazaarVoiceRatings show="reviews" productId={product?.slug}/>
        )}

        <MaisonetteOverviewImage
          data-vwo-id="MobilePaidMaisonetteOverviewImage"
          src={`${process.env.NEXT_PUBLIC_ASSET_HOST}/images/paid-pdp/maisonette_overview.png`}
          alt="Maisonette, good stuff for the kids in your life.
            We've got it all. You can trust it's the best. We make it magical."
          width="414"
          height="537"
        />
      </MobilePaidProduct>


      
      <PDPCarousels
        data-vwo-id="MobilePaidPDPCarousels"
        product={product}
        recentlyViewed={recentlyViewed}
        hasRecommendations={hasRecommendations}
      />
    </MobileProductWrapper>
  );
};

MobilePaidProductDetails.defaultProps = {
  product: null,
  hasImages: false,
  productType: '',
  hasRecommendations: false,
  recentlyViewed: [],
  meta: {},
  growthbookFeatureFlagValues: {},
};

MobilePaidProductDetails.propTypes = {
  product: PropTypes.object,
  hasImages: PropTypes.bool,
  productType: PropTypes.string,
  hasRecommendations: PropTypes.bool,
  recentlyViewed: PropTypes.array,
  meta: PropTypes.object,
  growthbookFeatureFlagValues: PropTypes.object,
};

export default MobilePaidProductDetails;
